import React from 'react';
import Toggle from 'material-ui/Toggle';
import { Button } from '@material-ui/core';
import { getRegionalColors } from '../../../../utils/regional-colors';
import { getFullItemName } from '../../../../utils/mrs-util';
import ItemIcon from '../ItemIcon';
import { formatNumber } from '../../../../utils/format-number-util';
import { injectIntl } from 'react-intl';
import './ItemRow.css';

const ItemRow = (props) => {
  const displayFrequency =
    props.frequency.substring(0, 1) == 'F'
      ? props.frequency.substring(1)
      : props.frequency;

  return (
    <div className="item-row-container">
      <div className="item-row-item-container">
        <div className="item-row-delivery-values-container">
          <div>
            <div className="item-row-delivery-value-label">Freq</div>
            <div className="item-row-delivery-value-number">
              {displayFrequency}
            </div>
          </div>
          <div>
            <div className="item-row-delivery-value-label">Qty</div>
            <div className="item-row-delivery-value-number">{props.qty}</div>
          </div>
        </div>
        <div className="item-row-edit-container">
          <Button
            onClick={props.handleEditClick}
            className="item-row-edit-button"
            style={{
              border: 'solid 1px #c6c6c6'
            }}
          >
            <div className="item-row-edit-button-content">
              <div>
                <ItemIcon item={props.item} />
              </div>
              <div style={{ color: getRegionalColors().backgroundColor }}>
                {props.intl.formatMessage({
                  id: 'edit'
                })}
              </div>
            </div>
          </Button>
        </div>
        <div className="item-row-item-info-container">
          <div>
            <div>{props.item.description}</div>
            <div className="item-row-item-info-description">
              {getFullItemName(props.item)}
            </div>
          </div>
          <div className="item-row-item-info-uses-price-container">
            <div>Uses: {props.item.numberOfUses}</div>
            <div>Price: ${formatNumber(props.rate, 2)}</div>
          </div>
        </div>
      </div>
      <div className="item-row-toggle">
        <Toggle
          toggled={props.checked}
          onToggle={(e, isInputChecked) => props.toggleItem(isInputChecked)}
        />
      </div>
    </div>
  );
};

export default injectIntl(ItemRow);
